var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / help-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.75781C10.957 5.75914 9.95716 6.17403 9.21968 6.91152C8.4822 7.649 8.0673 8.64886 8.06598 9.69181H10.066C10.066 8.62481 10.934 7.75781 12 7.75781C13.066 7.75781 13.934 8.62481 13.934 9.69181C13.934 10.2898 13.453 10.7238 12.718 11.3178C12.4779 11.5059 12.2472 11.7058 12.027 11.9168C11.029 12.9138 11 13.9728 11 14.0908V14.7578H13L12.999 14.1248C13 14.1088 13.032 13.7388 13.44 13.3318C13.59 13.1818 13.779 13.0318 13.975 12.8738C14.754 12.2428 15.933 11.2898 15.933 9.69181C15.9322 8.64887 15.5176 7.64885 14.7802 6.91128C14.0428 6.17372 13.0429 5.75887 12 5.75781ZM11 15.7578H13V17.7578H11V15.7578Z",
    fill: "#1B1A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.75781C6.486 1.75781 2 6.24381 2 11.7578C2 17.2718 6.486 21.7578 12 21.7578C17.514 21.7578 22 17.2718 22 11.7578C22 6.24381 17.514 1.75781 12 1.75781ZM12 19.7578C7.589 19.7578 4 16.1688 4 11.7578C4 7.34681 7.589 3.75781 12 3.75781C16.411 3.75781 20 7.34681 20 11.7578C20 16.1688 16.411 19.7578 12 19.7578Z",
    fill: "#1B1A1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.5b12ea862a064b130230fd23e96d084a.svg";
export { ForwardRef as ReactComponent };